export default __webpack_public_path__ + "static/media/876.babecd14.jpeg";